import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from './authorization.service';

// Restricts a route to NetFoundry support users. When authorization hasn't been obtained yet
// (e.g. a direct deep-link before any resolver ran), it loads it first, then checks isSupportUser();
// non-support users are redirected to the network dashboard.
@Injectable({ providedIn: 'root' })
export class SupportUserGuard {
    constructor(private authorization: AuthorizationService, private router: Router) {}

    async canActivate(): Promise<boolean> {
        if (!this.authorization.obtainedMopPermissions) {
            try {
                await this.authorization.getAuthorization();
            } catch {
                // Ignore — the isSupportUser() check below handles the denied case.
            }
        }
        if (this.authorization.isSupportUser()) {
            return true;
        }
        this.router.navigate(['/network/dashboard']);
        return false;
    }
}
